import { render, staticRenderFns } from "./HoldGeneralBodyMeeting.vue?vue&type=template&id=04c28606&"
import script from "./HoldGeneralBodyMeeting.vue?vue&type=script&lang=js&"
export * from "./HoldGeneralBodyMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports